function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _circle, _circle2, _path6;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import { Platform } from 'react-native';
import { createElement } from 'react';
var SvgKeepCustomersReturning = function SvgKeepCustomersReturning(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    x: 4,
    y: 4,
    fill: "#D1FAE5",
    rx: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#10B981",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M36 44c8-8 20-10 30-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#10B981",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m58 32 8 6-7 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#10B981",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M84 76c-8 8-20 10-30 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#10B981",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m62 88-8-6 7-6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#047857",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m38 70 3-9c1-3 4-5 7-5h24c3 0 6 2 7 5l3 9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 12,
    x: 36,
    y: 68,
    fill: "#FFF",
    stroke: "#047857",
    strokeWidth: 2.5,
    rx: 6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 82,
    r: 4,
    fill: "#D1FAE5",
    stroke: "#047857",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 82,
    r: 4,
    fill: "#D1FAE5",
    stroke: "#047857",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F43F5E",
    d: "M78 34c-3-3-3-7 0-9 2-2 5-1 6 1 1-2 4-3 6-1 3 2 3 6 0 9l-6 6z"
  })));
};
if (Platform.OS === 'web') {
  var ForwardRefNativeSvgIcon = /*#__PURE__*/React.forwardRef(SvgKeepCustomersReturning);
  SvgKeepCustomersReturning = function SvgKeepCustomersReturning(props, ref) {
    return /*#__PURE__*/createElement(ForwardRefNativeSvgIcon, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  };
}
var ForwardRef = /*#__PURE__*/forwardRef(SvgKeepCustomersReturning);
export default ForwardRef;